import React, { FunctionComponent, useEffect } from "react";
import { useDispatch } from "react-redux";
import { TIME_SYNC_INTERVAL } from "../../../../constants";
import { setConfig } from "../../../../store/config/actions";
import { useInterval } from "../../../../utils/useInterval";
import { useRetry } from "../../../../utils/useRetry";
import { useTimeOffset } from "./getTimeOffset";
import { Logger } from "../../../../logger/logger";

const log = new Logger("TimeSynchroniserContainer");

export interface TimeSynchroniserContainerProps {
  timeServerUrl: string;
}
export const TimeSynchroniserContainer: FunctionComponent<TimeSynchroniserContainerProps> = ({
  timeServerUrl,
}: TimeSynchroniserContainerProps) => {
  const dispatch = useDispatch();
  const { hasError, getTimeOffset, timeOffset } = useTimeOffset(timeServerUrl);

  // use exponential back off if getTimeOffset fails
  useRetry(hasError, getTimeOffset);
  useEffect(() => {
    getTimeOffset();
  }, [getTimeOffset]);

  useInterval(() => {
    getTimeOffset();
  }, TIME_SYNC_INTERVAL);

  useEffect(() => {
    if (timeOffset !== undefined) {
      log.info(`Setting new time offset value: ${timeOffset}ms.`);
      dispatch(setConfig({ timeOffset }));
    }
  }, [dispatch, timeOffset]);

  return <></>;
};
